// extracted by mini-css-extract-plugin
export const follow_us_card = "FollowUsModal-module--follow_us_card--2At_p";
export const follow_us_card__header = "FollowUsModal-module--follow_us_card__header--uszuz";
export const follow_us_card__title = "FollowUsModal-module--follow_us_card__title--2Yil6";
export const follow_us_card__close = "FollowUsModal-module--follow_us_card__close--2c_2b";
export const follow_us_card__container = "FollowUsModal-module--follow_us_card__container--5--tn";
export const follow_us_card__list = "FollowUsModal-module--follow_us_card__list--3RMwz";
export const follow_us_card__list_item = "FollowUsModal-module--follow_us_card__list_item--3aa_Z";
export const follow_us_card__button = "FollowUsModal-module--follow_us_card__button--3QZDb";